import { render, staticRenderFns } from "./type-wrapper.vue?vue&type=template&id=c5b290bc&scoped=true&"
import script from "./type-wrapper.vue?vue&type=script&lang=js&"
export * from "./type-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./type-wrapper.vue?vue&type=style&index=0&id=c5b290bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b290bc",
  null
  
)

export default component.exports